import React, { useEffect, useState } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";

import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import InfoIcon from "@mui/icons-material/Info";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PhotoCameraOutlinedIcon from "@mui/icons-material/PhotoCameraOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

import {
  GetInstructorProfileDetails,
  UpdateProfileDetails,
  CheckInstructorVerify,
} from "../../../api";

import ErrorAlert from "../../../commonFunctions/Alerts/ErrorAlert";
import { FILE_PATH } from "../../../commonFunctions/FilePaths";

const MyProfile = () => {
  // ========================
  // PROFILE DETAILS
  // ========================

  const [Primary_Email, setPrimary_Email] = useState("");

  const [first_Name, setfirst_Name] = useState("");
  const [last_name, setlast_name] = useState("");

  const [headline, setheadline] = useState("");
  const [biography, setbiography] = useState("");

  const [website, setwebsite] = useState("");

  const [twitter, settwitter] = useState("");
  const [facebook, setfacebook] = useState("");
  const [linkedin, setlinkedin] = useState("");
  const [youtube, setyoutube] = useState("");

  const [email, setemail] = useState("");

  const [profile_img, setprofile_img] = useState("");
  const [uploadImage, setuploadImage] = useState("");
  const [preview_img, setpreview_img] = useState("");

  // These values are still passed to the existing backend API.
  // Keeping them avoids changing UpdateProfileDetails right now.
  const [link_to_course, setlink_to_course] = useState("");
  const [external_ratings, setexternal_ratings] = useState("");
  const [
    external_number_of_number,
    setexternal_number_of_number,
  ] = useState("");
  const [any_comment, setany_comment] = useState("");

  const [btn_loading, setbtn_loading] = useState(false);

  const [
    checkInstructorVerification,
    setcheckInstructorVerification,
  ] = useState(null);

  const [
    isProfileSavedAndComplete,
    setIsProfileSavedAndComplete,
  ] = useState(true);

  // ========================
  // EMAIL VALIDATION
  // ========================

  const isValidEmail = (value) => {
    const emailPattern =
      /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    return emailPattern.test(value);
  };

  // ========================
  // LOAD PROFILE
  // ========================

  const loadProfileDetails = () => {
    GetInstructorProfileDetails(
      setPrimary_Email,
      setfirst_Name,
      setlast_name,
      setheadline,
      setbiography,
      setwebsite,
      settwitter,
      setfacebook,
      setlinkedin,
      setyoutube,
      setlink_to_course,
      setexternal_ratings,
      setexternal_number_of_number,
      setany_comment,
      setemail,
      setprofile_img,

      (result) => {
        const incomplete =
          !result.first_name ||
          !result.last_name ||
          !result.headline ||
          !result.biography ||
          !result.profile_img;

        setIsProfileSavedAndComplete(!incomplete);
      }
    );
  };

  // ========================
  // INITIAL LOAD
  // ========================

  useEffect(() => {
    loadProfileDetails();

    /*
     * Keeping existing verification check.
     * If this API requires a course code in your project,
     * we can later move it out of the profile page.
     */
    CheckInstructorVerify(
      null,
      setcheckInstructorVerification
    );
  }, []);

  // ========================
  // IMAGE UPLOAD
  // ========================

  const handleImageUpload = (event) => {
    const input = event.target;

    if (!input.files || !input.files[0]) {
      return;
    }

    const file = input.files[0];

    setuploadImage(file);

    const reader = new FileReader();

    reader.onload = (e) => {
      setpreview_img(e.target.result);
    };

    reader.readAsDataURL(file);
  };

  // ========================
  // SAVE PROFILE
  // ========================

  const handleProfileData = () => {
    if (
      profile_img === "" &&
      uploadImage === "" &&
      preview_img === ""
    ) {
      ErrorAlert(
        "Error",
        "Please add a profile image"
      );

      return;
    }

    if (first_Name.trim() === "") {
      ErrorAlert(
        "Error",
        "Please Enter First Name"
      );

      return;
    }

    if (last_name.trim() === "") {
      ErrorAlert(
        "Error",
        "Please Enter Last Name"
      );

      return;
    }

    if (headline.trim() === "") {
      ErrorAlert(
        "Error",
        "Please Enter Headline"
      );

      return;
    }

    if (biography.trim() === "") {
      ErrorAlert(
        "Error",
        "Please Enter Biography"
      );

      return;
    }

    /*
     * Keep validation only if an external rating
     * already exists in old data.
     */
    if (
      external_ratings !== null &&
      external_ratings !== undefined &&
      external_ratings !== ""
    ) {
      const rating =
        parseFloat(external_ratings);

      if (
        Number.isNaN(rating) ||
        rating < 0 ||
        rating > 5
      ) {
        ErrorAlert(
          "Error",
          "External rating should be between 0 to 5"
        );

        return;
      }
    }

    if (email.trim() !== "") {
      if (!isValidEmail(email)) {
        ErrorAlert(
          "Error",
          "Please enter a valid email address."
        );

        return;
      }
    }

    UpdateProfileDetails(
      uploadImage,
      first_Name,
      last_name,
      headline,
      biography,
      website,
      twitter,
      facebook,
      linkedin,
      youtube,
      link_to_course,
      external_ratings,
      external_number_of_number,
      any_comment,
      email,
      setbtn_loading,

      () => {
        setIsProfileSavedAndComplete(true);

        setuploadImage("");
        setpreview_img("");

        loadProfileDetails();
      }
    );
  };

  // ========================
  // PROFILE IMAGE
  // ========================

  const getProfileImage = () => {
    if (preview_img !== "") {
      return preview_img;
    }

    if (profile_img !== "") {
      return `${FILE_PATH}/${profile_img}`;
    }

    return "https://img-c.udemycdn.com/user/200_H/anonymous_3.png";
  };

  // ========================
  // RENDER
  // ========================

  return (
    <div
      className="all-courses-container mb-5"
      style={{
        paddingBottom: "30px",
      }}
    >
      {/* ========================
          PAGE HEADER
      ======================== */}

      <div
        style={{
          marginBottom: "28px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "14px",
          }}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              borderRadius: "14px",

              display: "flex",
              justifyContent: "center",
              alignItems: "center",

              background:
                "linear-gradient(135deg, #17082d, #45206b)",

              boxShadow:
                "0 10px 25px rgba(23, 8, 45, 0.15)",

              color: "#ffffff",
            }}
          >
            <PersonOutlineIcon />
          </div>

          <div>
            <Typography
              variant="h4"
              sx={{
                color: "#17082d",
                fontWeight: 700,
                margin: 0,
              }}
            >
              My Profile
            </Typography>

            <Typography
              sx={{
                color: "#7a7482",
                fontSize: "14px",
                marginTop: "4px",
              }}
            >
              Manage your personal and
              professional information.
            </Typography>
          </div>
        </div>
      </div>

      {/* ========================
          PROFILE INCOMPLETE ALERT
      ======================== */}

      {!isProfileSavedAndComplete && (
        <Alert
          variant="danger"
          style={{
            borderRadius: "12px",
            border:
              "1px solid rgba(211, 47, 47, 0.18)",

            marginBottom: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
            }}
          >
            <InfoIcon
              style={{
                color: "#d32f2f",
                marginRight: "10px",
              }}
            />

            <div>
              <strong>
                Profile Incomplete:
              </strong>{" "}

              Please complete your profile
              details including first name,
              last name, headline, biography,
              and profile picture.
            </div>
          </div>
        </Alert>
      )}

      {/* ========================
          VERIFICATION ALERT
      ======================== */}

      {checkInstructorVerification === 0 && (
        <Alert
          variant="warning"
          style={{
            borderRadius: "12px",
            marginBottom: "18px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              textAlign: "left",
            }}
          >
            <InfoIcon
              style={{
                color: "#ed6c02",
                marginRight: "10px",
              }}
            />

            <div>
              <strong>
                Verification Required:
              </strong>{" "}

              Your account is not verified
              yet. Please visit the{" "}

              <a href="/verification">
                Verification Page
              </a>

              {" "}to verify your identity.
            </div>
          </div>
        </Alert>
      )}

      {/* ========================
          PROFILE CARD
      ======================== */}

      <Card
        sx={{
          borderRadius: "20px",

          border:
            "1px solid rgba(23, 8, 45, 0.07)",

          boxShadow:
            "0 16px 45px rgba(23, 8, 45, 0.06)",

          overflow: "hidden",
        }}
      >
        {/* ========================
            CARD HEADER
        ======================== */}

        <div
          style={{
            padding: "25px 30px",

            background:
              "linear-gradient(135deg, rgba(23,8,45,0.045), rgba(91,45,134,0.025))",

            borderBottom:
              "1px solid rgba(23,8,45,0.065)",
          }}
        >
          <Typography
            sx={{
              color: "#17082d",
              fontWeight: 700,
              fontSize: "20px",
            }}
          >
            Your Profile
          </Typography>

          <Typography
            sx={{
              color: "#7b7580",
              fontSize: "13px",
              marginTop: "4px",
            }}
          >
            Update the information shown
            across your QualiGrad profile.
          </Typography>
        </div>

        {/* ========================
            CARD BODY
        ======================== */}

        <div
          style={{
            padding: "32px",
          }}
        >
          {/* ========================
              PROFILE IMAGE
          ======================== */}

          <div
            className="row"
            style={{
              marginBottom: "32px",
              alignItems: "center",
            }}
          >
            <div className="col-lg-8 col-md-7">
              <label
                style={{
                  color: "#17082d",
                  fontWeight: 600,
                  marginBottom: "5px",
                  display: "block",
                }}
              >
                Profile Picture
              </label>

              <span
                style={{
                  color: "#86808b",
                  fontSize: "12px",
                }}
              >
                Minimum 200 × 200 pixels.
                Maximum 6000 × 6000 pixels.
              </span>

              <div
                style={{
                  marginTop: "18px",

                  width: "135px",
                  height: "135px",

                  borderRadius: "18px",
                  overflow: "hidden",

                  background: "#f7f5f9",

                  border:
                    "1px solid rgba(23,8,45,0.08)",

                  boxShadow:
                    "0 8px 24px rgba(23,8,45,0.06)",

                  padding: "5px",
                }}
              >
                <img
                  id="previewImage"
                  src={getProfileImage()}
                  alt="Profile"
                  style={{
                    width: "100%",
                    height: "100%",

                    objectFit: "cover",

                    borderRadius: "14px",
                  }}
                />
              </div>
            </div>

            <div className="col-lg-4 col-md-5">
              <div
                style={{
                  marginTop: "20px",
                }}
              >
                <label
                  htmlFor="formFile"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",

                    color: "#17082d",
                    fontWeight: 600,

                    marginBottom: "9px",
                  }}
                >
                  <PhotoCameraOutlinedIcon
                    sx={{
                      fontSize: "18px",
                    }}
                  />

                  Upload Image

                  <span
                    style={{
                      color: "#dc3545",
                    }}
                  >
                    *
                  </span>
                </label>

                <input
                  onChange={handleImageUpload}
                  accept="image/*"
                  className="form-control"
                  type="file"
                  id="formFile"
                />
              </div>
            </div>
          </div>

          {/* DIVIDER */}

          <div
            style={{
              height: "1px",

              background:
                "rgba(23, 8, 45, 0.07)",

              marginBottom: "28px",
            }}
          />

          {/* ========================
              ACCOUNT DETAILS
          ======================== */}

          <Typography
            sx={{
              color: "#17082d",
              fontWeight: 700,
              fontSize: "16px",
              marginBottom: "20px",
            }}
          >
            Account Information
          </Typography>

          <div className="row">
            {/* PRIMARY EMAIL */}

            <div className="col-lg-6 col-md-6">
              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Primary Email
                </label>

                <input
                  value={Primary_Email}
                  disabled
                  type="email"
                  className="form-control"
                  readOnly
                  placeholder="Email"
                  style={{
                    background: "#f7f6f8",
                  }}
                />
              </div>
            </div>

            {/* SECONDARY EMAIL */}

            <div className="col-lg-6 col-md-6">
              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Contact Email
                </label>

                <input
                  value={email}
                  onChange={(e) =>
                    setemail(e.target.value)
                  }
                  type="email"
                  className="form-control"
                  placeholder="Enter an Email"
                />
              </div>
            </div>
          </div>

          {/* ========================
              PERSONAL DETAILS
          ======================== */}

          <Typography
            sx={{
              color: "#17082d",
              fontWeight: 700,
              fontSize: "16px",

              marginTop: "8px",
              marginBottom: "20px",
            }}
          >
            Personal Information
          </Typography>

          <div className="row">
            {/* LEFT */}

            <div className="col-lg-6 col-md-6">
              {/* FIRST NAME */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  First Name

                  <span className="text-danger">
                    {" "}*
                  </span>
                </label>

                <input
                  value={first_Name}
                  onChange={(e) =>
                    setfirst_Name(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="First Name"
                />
              </div>

              {/* LAST NAME */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Last Name

                  <span className="text-danger">
                    {" "}*
                  </span>
                </label>

                <input
                  value={last_name}
                  onChange={(e) =>
                    setlast_name(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="Last Name"
                />
              </div>

              {/* HEADLINE */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Headline

                  <span className="text-danger">
                    {" "}*
                  </span>
                </label>

                <div className="input-group">
                  <input
                    maxLength={60}
                    value={headline}
                    onChange={(e) =>
                      setheadline(
                        e.target.value
                      )
                    }
                    type="text"
                    className="form-control"
                    placeholder="Your occupation, specialization and qualification"
                  />

                  <span
                    className="input-group-text"
                    style={{
                      background: "#f7f5f9",
                    }}
                  >
                    {60 - headline.length}
                  </span>
                </div>
              </div>
            </div>

            {/* RIGHT */}

            <div className="col-lg-6 col-md-6">
              {/* WEBSITE */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Website
                </label>

                <input
                  value={website}
                  onChange={(e) =>
                    setwebsite(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="https://example.com"
                />
              </div>

              {/* X */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  <i className="fa-brands fa-square-x-twitter" />

                  {" "}X
                </label>

                <input
                  value={twitter}
                  onChange={(e) =>
                    settwitter(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="Profile URL"
                />
              </div>

              {/* FACEBOOK */}

              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  <i className="fa-brands fa-facebook" />

                  {" "}Facebook
                </label>

                <input
                  value={facebook}
                  onChange={(e) =>
                    setfacebook(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="Profile URL"
                />
              </div>
            </div>

            {/* BIOGRAPHY */}

            <div className="col-12">
              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  Biography

                  <span className="text-danger">
                    {" "}*
                  </span>
                </label>

                <textarea
                  placeholder="Write a short professional biography."
                  value={biography}
                  onChange={(e) =>
                    setbiography(
                      e.target.value
                    )
                  }
                  className="form-control"
                  rows="5"
                />
              </div>
            </div>
          </div>

          {/* ========================
              SOCIAL LINKS
          ======================== */}

          <Typography
            sx={{
              color: "#17082d",
              fontWeight: 700,
              fontSize: "16px",

              marginTop: "8px",
              marginBottom: "20px",
            }}
          >
            Social Links
          </Typography>

          <div className="row">
            {/* LINKEDIN */}

            <div className="col-lg-6 col-md-6">
              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  <i className="fa-brands fa-linkedin" />

                  {" "}LinkedIn
                </label>

                <input
                  value={linkedin}
                  onChange={(e) =>
                    setlinkedin(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="LinkedIn profile URL"
                />
              </div>
            </div>

            {/* YOUTUBE */}

            <div className="col-lg-6 col-md-6">
              <div className="mb-4">
                <label
                  className="form-label"
                  style={{
                    fontWeight: 600,
                    color: "#33253f",
                  }}
                >
                  <i className="fa-brands fa-youtube" />

                  {" "}YouTube
                </label>

                <input
                  value={youtube}
                  onChange={(e) =>
                    setyoutube(
                      e.target.value
                    )
                  }
                  type="text"
                  className="form-control"
                  placeholder="YouTube channel URL"
                />
              </div>
            </div>
          </div>

          {/* ========================
              SAVE SECTION
          ======================== */}

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",

              borderTop:
                "1px solid rgba(23,8,45,0.07)",

              marginTop: "10px",
              paddingTop: "25px",
            }}
          >
            {btn_loading ? (
              <Button
                disabled
                variant="contained"
                sx={{
                  minWidth: "145px",

                  background:
                    "#17082d",

                  borderRadius:
                    "10px",

                  padding:
                    "10px 25px",
                }}
              >
                <Spinner
                  size="sm"
                  animation="border"
                  variant="light"
                />
              </Button>
            ) : (
              <Button
                onClick={handleProfileData}
                variant="contained"
                startIcon={
                  <SaveOutlinedIcon />
                }
                sx={{
                  minWidth: "160px",

                  background:
                    "#17082d",

                  borderRadius:
                    "10px",

                  padding:
                    "10px 24px",

                  textTransform:
                    "none",

                  fontWeight: 600,

                  boxShadow:
                    "0 8px 20px rgba(23,8,45,0.16)",

                  "&:hover": {
                    background:
                      "#2c104b",

                    boxShadow:
                      "0 10px 24px rgba(23,8,45,0.22)",
                  },
                }}
              >
                Save Changes
              </Button>
            )}
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MyProfile;

